(() => {
  const observers = new Map();
  const pendingIntent = new Set();
  const mediaObservers = new Map();
  let tvDiscovery;

  function watchTvMedia(root) {
    // Native lazy media loading keeps the floating cover eager and postpones
    // hidden feed previews. Browsers that ignore the attribute keep the app's own loader.
    const watchContainer = block => {
      if (mediaObservers.has(block)) return;
      const selector = 'video.snpt__vid, video.snpt-product-preview-item-vid';
      const enhance = node => {
        if (!(node instanceof Element)) return;
        if (node.matches(selector) && !node.hasAttribute('loading')) node.setAttribute('loading', 'lazy');
        node.querySelectorAll(selector).forEach(video => {
          if (!video.hasAttribute('loading')) video.setAttribute('loading', 'lazy');
        });
      };
      const observer = new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) enhance(node);
      });
      observer.observe(block, { childList: true, subtree: true });
      mediaObservers.set(block, observer);
      enhance(block);
    };
    root.querySelectorAll('.snpt_widget--sauce-tv').forEach(watchContainer);
    // Sauce moves the hidden feed out of the theme block into a direct body
    // child. Watch only those additions, then observe the feed itself.
    if (!tvDiscovery && document.body && document.querySelector('.snapppt-shopify-app-block-sauce-tv')) {
      tvDiscovery = new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) {
          if (node instanceof Element && node.matches('.snpt_widget--sauce-tv')) watchContainer(node);
        }
      });
      tvDiscovery.observe(document.body, { childList: true });
    }
  }

  function activate(template) {
    pendingIntent.delete(template);
    observers.get(template)?.disconnect();
    observers.delete(template);
    if (!template.isConnected) return;
    const original = template.content.querySelector('script');
    if (!original) return;
    const script = document.createElement('script');
    for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
    script.textContent = original.textContent;
    // The SDK uses its own script's parent as the gallery mount point.
    template.replaceWith(script);
  }

  function watch(root) {
    watchTvMedia(root);
    root.querySelectorAll('template[data-deferred-sauce]').forEach(template => {
      if (observers.has(template) || pendingIntent.has(template)) return;
      if (template.dataset.deferredSauce === 'intent') {
        if (document.documentElement.dataset.deferredUiReady === 'true') activate(template);
        else pendingIntent.add(template);
        return;
      }
      if (!('IntersectionObserver' in window)) { activate(template); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) activate(template);
      }, { rootMargin: '1500px 0px' });
      observers.set(template, observer);
      if (template.parentElement) observer.observe(template.parentElement);
      else activate(template);
    });
  }

  document.addEventListener('asyncLazyLoad', () => {
    if (document.documentElement.dataset.deferredUiReady === 'true') pendingIntent.forEach(activate);
  });
  watch(document);
  document.addEventListener('shopify:section:load', event => watch(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const template of pendingIntent) {
      if (event.target.contains(template)) pendingIntent.delete(template);
    }
    for (const [template, observer] of observers) {
      if (event.target.contains(template)) { observer.disconnect(); observers.delete(template); }
    }
    for (const [block, observer] of mediaObservers) {
      if (event.target.contains(block)) { observer.disconnect(); mediaObservers.delete(block); }
    }
  });
})();
